import React from 'react'

const DtesViewAlumnos = ({ data }) => {
  // console.log(data);
  let totalMonto = 0;

  const datosUsuario = JSON.parse(localStorage.getItem('dataUser'));

  const dataFiltrada = datosUsuario && datosUsuario.perfil === 'Alumnos'
    ? data.filter((el) => el.mh.estado === 'PROCESADO')
    : data;


  function downloadPDF(pdf, codigo) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = codigo + ".pdf";
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////   CONTROL DE AUTIENTICANIÓN Y CONSUMO DE API    ///////////////////////////////////////////////////////////////

  //Vencimiento de token validación
  const vencimientoToken = () => {

    if (localStorage.getItem('tokenExpires')) {
      const now = new Date();
      const dateExperite = new Date(localStorage.getItem('tokenExpires'));

      if (dateExperite > now) {
        return 0; //Valido
      } else {
        return 1; //No valido
      }
    }

    return 1; //No existe token o no valido

  }

  //Autenticación con FACTURES
  const autenticacionFactured = async () => {
    let token = '';

    const user = '34343';
    const pass = 'dsde';
    const url = 'sddsds';

    const dataAuth = await fetch(url, {
      method: "post",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        User: user,
        Password: pass
      })
    })

    const auth = await dataAuth.json();

    if (auth.ExpiresToken) {
      localStorage.setItem('tokenExpires', auth.ExpiresToken)
      localStorage.setItem('token', auth.AuthToken)
    }

  }

  //Enviando dte a FACTURED
  const sendtDataPost = async (dataForm, token, codigoGeneracion) => {
    const url = 'dsdsewe34343';
    if (url) {
      try {
        const entryPointLogin = url;
        return await fetch(entryPointLogin, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`
          },
          body: dataForm
        })
          .then(result => result.json())
          .then((data) => {
            if (data.DescripcionEstatus === 'Habilitado') {
              downloadPDF(data.pdfDTE, codigoGeneracion);
            } else {
              alert('FACTURA NO DISPONIBLE');
            }
            return data;
          })
      } catch (error) {
        console.log(error);
        return error;
      }
    } else {
      let res;
      return res.json({
        'message': 'EndPoint no definido'
      });
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  const detalleFactura = async (fecha, codigoGeneracion, tipoDte) => {

    const data = JSON.stringify({
      'CodigoGeneracion': codigoGeneracion,
      'FechaEmision': fecha,
      'TipoDte': tipoDte
    })

    //Validando vencimiento del token
    if (+vencimientoToken() === 1) {

      //Autenticando
      await autenticacionFactured();

      //Mandar DTE token nuevo token
      sendtDataPost(data, localStorage.getItem('token'), codigoGeneracion);
    } else {

      //Mandar DTE token todabía valido o no vencido
      sendtDataPost(data, localStorage.getItem('token'), codigoGeneracion);
    }


  }


  const getPDF = (e) => {
    const codGeneracion = e.target.dataset.codigogeneracion
    const fecha = e.target.dataset.fecha
    // const transaccion = e.target.dataset.transaccion
    const tipoDte = '01';

    detalleFactura(fecha.substr(0, 10), codGeneracion, tipoDte)

  }

  return (
    <>
      <h3 className='mt-4 mb-3'>Historia de pagos</h3>
      <div>
        {
          dataFiltrada.map((el, key) => {
            totalMonto = 0;
            return (
              <div key={key} className='card'>
                <div className='card-header'>
                  <i className='fa fa-file-text-o mr-2' aria-hidden='true'></i>
                  Pago {key + 1}
                </div>
                <div className='card-body'>
                  <div className='row'>
                    <div className='col-lg-6'>
                      <div className='table-responsive'>
                        <table className='table table-sm'>
                          <thead>
                            <tr>
                              <th scope='col'>#</th>
                              <th scope='col'>Descripción</th>
                              <th scope='col' className='text-right'>Monto</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              el.detalles.map((elemento, k) => {
                                totalMonto += +elemento.preciounitario
                                return (
                                  <tr key={k}>
                                    <td>{k + 1}</td>
                                    <td>{elemento.descripcion}</td>
                                    <td className='text-right'>${elemento.preciounitario}</td>
                                  </tr>
                                )
                              })
                            }
                          </tbody>
                          <tfoot>
                            <tr>
                              <td></td>
                              <th scope='row'>Total</th>
                              <td className='text-right'><b>${totalMonto}</b></td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div className='col-lg-6'>
                      <div className='table-responsive'>
                        <table className='table table-sm'>
                          <tbody>
                            <tr>
                              <th scope='row'>Código generación</th>
                              <td>{el.mh.codigo_generacion ? el.mh.codigo_generacion : el.mh.CodigoGeneracion}</td>
                            </tr>
                            <tr>
                              <th scope='row'>Número de control</th>
                              <td>{el.mh.numero_control ? el.mh.numero_control : el.mh.NumeroControl}</td>
                            </tr>
                            <tr>
                              <th scope='row'>Sello recibido</th>
                              <td>{el.mh.sello_recibido ? el.mh.sello_recibido : el.mh.SelloRecibido}</td>
                            </tr>
                            <tr>
                              <th scope='row'>Fecha procesamiento</th>
                              <td>{el.mh.fecha_procesado ? el.mh.fecha_procesado : el.mh.FechaProcesamiento}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
    </>
  )
}

export default DtesViewAlumnos
